import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openSnack: false,
  openErrorSnackBar: false,
  vertical: "top",
  horizontal: "center",
  autoHideDuration: 5000,
  message: "",
  // severity: "success",
};

const snackBarSlice = createSlice({
  name: "snackBarSlice",
  initialState,
  reducers: {
    openSnackBar: (state, action) => {
      console.log(action.payload);
      state.openSnack = true;
      state.message = action.payload.message;
      // state.severity = action.payload.severity;
    },
    closeSnackBar: (state, action) => {
      state.openSnack = false;
      state.message = "";
    },

    openErrorSnack: (state, action) => {
      state.openErrorSnackBar = true;
      state.message = action.payload.message;
    },
    closeErrorSnack: (state, action) => {
      state.openErrorSnackBar = false;
      state.message = "";
    },
  },
});

export const { openSnackBar, closeSnackBar, openErrorSnack, closeErrorSnack } =
  snackBarSlice.actions;

export default snackBarSlice.reducer;
